<template>
  <commodity-portfolio-scenarios
    :Analytics="Analytics"
    :asset="Analytics.assetType"
    :colorTheme="colorTheme"
    :idChart="idChart"
    :isPrices="isPrices"
    :loadingAll="loadingAll"
    :processData="processData"
    :renderChartSignal="renderChartSignal"
    @eventOnUserShow="onUserShow"
    @changeInfoTable="changeInfoTable"
    @onTableFormat="onHoverChart"
  />
</template>
<script>
import { defaultAnalytics } from "@/_core/data/Analytics/AnalyticsHelpers.js";
import CommodityPortfolioScenarios from "./CommodityPortfolioScenarios.vue";
export default {
  components: { CommodityPortfolioScenarios },
  name: "CommodityPriceChart",
  props: {
    Analytics: {
      required: true,
      default: defaultAnalytics()
    },
    asset: { required: false, default: "commodity" },
    colorTheme: { required: true, type: Boolean, default: true },
    loadingAll: { required: true, type: Boolean, default: false },
    processData: { required: true },
    renderChartSignal: { required: true, default: 0 }
  },
  data() {
    return {
      isPrices: true,
      idChart: "rates"
    };
  },
  methods: {
    changeInfoTable(val) {
      this.$emit("changeInfoTable", val);
    },
    onUserShow(str) {
      this.$emit("eventOnUserShow", str);
    },
    onHoverChart(val) {
      this.$emit("onTableFormat", val);
    }
  }
};
</script>
